import React from "react";
import { CButton, CFormTextarea } from "@coreui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Formik } from "formik";
import { contentModeration } from "@/constants/translation/contentModeration.translation";

const popups = contentModeration.popups;
const REASON_MAX_LENGTH = 500;

/**
 * Deactivate popup with an OPTIONAL reason (modelled on MarkFraudulentDialog, which requires one).
 * @param {Object} params
 * @param {function} params.t - Translation function.
 * @param {function} params.onConfirm - Called with the trimmed reason ("" when left empty).
 */
export const showDeactivateDialog = ({ t, onConfirm }) => {
  confirmAlert({
    customUI: ({ onClose }) => (
      <Formik
        initialValues={{ reason: "" }}
        onSubmit={(values, { setSubmitting }) => {
          onConfirm(values.reason.trim());
          setSubmitting(false);
          onClose();
        }}
      >
        {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
          <div className="alert-box admin-status-popup">
            <div className="alert-popup">
              <FontAwesomeIcon
                className="alert-close"
                icon={faClose}
                onClick={onClose}
              />
              <h2 className="alert-title">{t(popups.deactivate.heading)}</h2>
              <p className="text-center mb-3">{t(popups.deactivate.message)}</p>
              <div className="mb-3 text-start">
                <CFormTextarea
                  id="reason"
                  name="reason"
                  rows={3}
                  maxLength={REASON_MAX_LENGTH}
                  placeholder={t(popups.deactivate.reason_placeholder)}
                  value={values.reason}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>
              <div className="d-flex gap-2 justify-content-center flex-nowrap">
                <CButton
                  color="primary"
                  className="table-delete-button"
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                >
                  {t(popups.yes)}
                </CButton>
                <CButton
                  className="table-primary-button"
                  color="danger"
                  onClick={onClose}
                  disabled={isSubmitting}
                >
                  {t(popups.no)}
                </CButton>
              </div>
            </div>
          </div>
        )}
      </Formik>
    ),
  });
};

/**
 * Plain Yes / No confirmation (reactivate, delete).
 * @param {Object} params
 * @param {function} params.t - Translation function.
 * @param {{heading: string, message: string}} params.texts - Translation keys of the popup texts.
 * @param {function} params.onConfirm - Called when the admin confirms.
 */
export const showConfirmDialog = ({ t, texts, onConfirm }) => {
  confirmAlert({
    customUI: ({ onClose }) => (
      <div className="alert-box">
        <div className="alert-popup">
          <FontAwesomeIcon
            className="alert-close"
            icon={faClose}
            onClick={onClose}
          />
          <h2 className="alert-title">{t(texts.heading)}</h2>
          <p className="text-center mb-3">{t(texts.message)}</p>
          <div className="d-flex gap-2 justify-content-center">
            <CButton
              color="primary"
              className="table-delete-button"
              onClick={() => {
                onConfirm();
                onClose();
              }}
            >
              {t(popups.yes)}
            </CButton>
            <CButton
              className="table-primary-button"
              color="danger"
              onClick={onClose}
            >
              {t(popups.no)}
            </CButton>
          </div>
        </div>
      </div>
    ),
  });
};
